"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidImageTypes = exports.ValidImageExtensions = exports.ValidExtensions = exports.CommonExtensions = void 0;
var CommonExtensions;
(function (CommonExtensions) {
    CommonExtensions["bmp"] = "bmp";
    CommonExtensions["jpeg"] = "jpeg";
    CommonExtensions["jpg"] = "jpg";
    CommonExtensions["png"] = "png";
    CommonExtensions["svg"] = "svg";
    CommonExtensions["tiff"] = "tiff";
    CommonExtensions["webp"] = "webp";
})(CommonExtensions = exports.CommonExtensions || (exports.CommonExtensions = {}));
var ValidExtensions;
(function (ValidExtensions) {
    // common extensions
    ValidExtensions["bmp"] = "bmp";
    ValidExtensions["jpeg"] = "jpeg";
    ValidExtensions["jpg"] = "jpg";
    ValidExtensions["png"] = "png";
    ValidExtensions["svg"] = "svg";
    ValidExtensions["tiff"] = "tiff";
    ValidExtensions["webp"] = "webp";
    // valid extensions
    ValidExtensions["ai"] = "ai";
    ValidExtensions["cad"] = "cad";
    ValidExtensions["csv"] = "csv";
    ValidExtensions["doc"] = "doc";
    ValidExtensions["docx"] = "docx";
    ValidExtensions["dwg"] = "dwg";
    ValidExtensions["dxf"] = "dxf";
    ValidExtensions["eps"] = "eps";
    ValidExtensions["html"] = "html";
    ValidExtensions["key"] = "key";
    ValidExtensions["md"] = "md";
    ValidExtensions["numbers"] = "numbers";
    ValidExtensions["odt"] = "odt";
    ValidExtensions["pages"] = "pages";
    ValidExtensions["pdf"] = "pdf";
    ValidExtensions["pps"] = "pps";
    ValidExtensions["ppsx"] = "ppsx";
    ValidExtensions["ppt"] = "ppt";
    ValidExtensions["pptx"] = "pptx";
    ValidExtensions["ps"] = "ps";
    ValidExtensions["psd"] = "psd";
    ValidExtensions["rtf"] = "rtf";
    ValidExtensions["sdw"] = "sdw";
    ValidExtensions["step"] = "step";
    ValidExtensions["stp"] = "stp";
    ValidExtensions["tex"] = "tex";
    ValidExtensions["tif"] = "tif";
    ValidExtensions["txt"] = "txt";
    ValidExtensions["wpd"] = "wpd";
    ValidExtensions["wps"] = "wps";
    ValidExtensions["xls"] = "xls";
    ValidExtensions["xlsx"] = "xlsx";
    ValidExtensions["xps"] = "xps";
})(ValidExtensions = exports.ValidExtensions || (exports.ValidExtensions = {}));
var ValidImageExtensions;
(function (ValidImageExtensions) {
    // common extensions
    ValidImageExtensions["bmp"] = "bmp";
    ValidImageExtensions["jpeg"] = "jpeg";
    ValidImageExtensions["jpg"] = "jpg";
    ValidImageExtensions["png"] = "png";
    ValidImageExtensions["svg"] = "svg";
    ValidImageExtensions["tiff"] = "tiff";
    ValidImageExtensions["webp"] = "webp";
    //valid image extensions
    ValidImageExtensions["gif"] = "gif";
})(ValidImageExtensions = exports.ValidImageExtensions || (exports.ValidImageExtensions = {}));
var ValidImageTypes;
(function (ValidImageTypes) {
    ValidImageTypes["image/bmp"] = "image/bmp";
    ValidImageTypes["image/gif"] = "image/gif";
    ValidImageTypes["image/jpeg"] = "image/jpeg";
    ValidImageTypes["image/jpg"] = "image/jpg";
    ValidImageTypes["image/png"] = "image/png";
    ValidImageTypes["image/svg"] = "image/svg";
    ValidImageTypes["image/tiff"] = "image/tiff";
    ValidImageTypes["image/webp"] = "image/webp";
})(ValidImageTypes = exports.ValidImageTypes || (exports.ValidImageTypes = {}));
